import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import React from "react";

library.add(faUpRightFromSquare);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const PublicationList = ({ data = [], heading, heading_sub, authors }) => {
  const byMonthDesc = (a, b) => MONTHS.indexOf(b.month) - MONTHS.indexOf(a.month);
  const grouped = [...data].sort(byMonthDesc).reduce((acc, item) => {
    if (!acc[item.year]) acc[item.year] = [];
    acc[item.year].push(item);
    return acc;
  }, {});

  const sortedYears = Object.keys(grouped).sort((a, b) => b - a);

  const renderAuthors = (authorIds, authorsDB, isJapanese) => {
    if (!authorIds || authorIds.length === 0) return null;
    const lang = isJapanese ? "ja" : "en";

    const nameElements = authorIds.map((id) => {
      const author = authorsDB[id];
      if (!author) return <span key={id}>{id}</span>;

      const name = author[lang];
      const isMe = author.isMe === true;

      return isMe ? (
        <strong key={id} style={{ textDecoration: "underline" }}>
          {name}
        </strong>
      ) : (
        <span key={id}>{name}</span>
      );
    });

    // --- 表記ルール ---
    if (nameElements.length === 1) return nameElements[0];

    if (isJapanese) {
      // 日本語は「, 」区切り
      return nameElements.reduce((acc, cur, i) => [
        acc,
        <span key={`sep-${i}`}>, </span>,
        cur,
      ]);
    } else {
      // 英語は「, and」で結合
      if (nameElements.length === 2)
        return (
          <>
            {nameElements[0]} and {nameElements[1]}
          </>
        );

      return (
        <>
          {nameElements.slice(0, -1).map((n, i) => (
            <React.Fragment key={i}>
              {n}
              {i < nameElements.length - 2 && ", "}
            </React.Fragment>
          ))}
          , and {nameElements[nameElements.length - 1]}
        </>
      );
    }
  };
  if (!data || data.length === 0) return null;
  return (
    <div className="pub-list-wrapper">
      {heading && (
        <h2 className="dflex h2-box"><span>#</span>
          {heading}
          {heading_sub && heading_sub.trim() !== "" && (
            <div className="pub-h-sub dflex dflexac gap-m">
                <span>/</span>
                <span>{heading_sub}</span>
            </div>
          )}
        </h2>
      )}

      {sortedYears.map((year) => (
        <div key={year} className="dflex">
          <h3 className="year-heading">{year}</h3>
          <ul className="dflexc publication-year-list">
            {grouped[year].map((pub, i) => {
              const datePart = [];
              if (pub.month) datePart.push(pub.month);
              if (!pub.year_invisible && pub.year) datePart.push(pub.year);
              const dateString =
                datePart.length > 0 ? `${datePart.join(" ")}` : "";

              return (
                <li key={i}>
                  {renderAuthors(pub.authors, authors, pub.authors_ja)}
                  {`, “${pub.title},”`}
                  {pub.conf && !/[\u3000-\u9fff]/.test(pub.conf) && <> in<span className="pub-italic"> Proceedings of </span></>}
                  {pub.conf && <><span className="pub-italic">{pub.conf}</span>, </>}
                  {pub.journal && <> <span className='pub-italic'>{pub.journal}</span>,</>}
                  {pub.at && ` ${pub.at}, `}
                  {pub.vol && ` vol. ${pub.vol}, `}
                  {pub.pages && ` pp. ${pub.pages}, `}
                  {dateString}
                  {pub.in_ja === true && ` (in Japanese)`}
                  {pub.other && ` ${pub.other}`}
                  {pub.links && Object.keys(pub.links).length > 0 && (
                    <>
                      {" "}
                      {Object.entries(pub.links).map(([key, url], idx) => (
                        <span key={idx}>
                          {" "}
                          <span className="pub-link">
                            [
                            <a
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {key}
                            </a>
                            <FontAwesomeIcon
                              icon="up-right-from-square"
                              className="fa pub-link-icon font-s"
                            />
                            ]
                          </span>
                        </span>
                      ))}
                    </>
                  )}
                  .
                  {Array.isArray(pub.awards) && pub.awards.length > 0 && (
                    <>
                      {pub.awards.map((award, idx) => (
                        <span key={idx} className="pub-awards">
                          {award}
                        </span>
                      ))}
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default PublicationList;
